import {FrameworkConfiguration} from 'aurelia-framework';



export function configure(config: FrameworkConfiguration) {
  config.globalResources([
    './attributes/active-on-anchor',
    './attributes/sneak',
    './attributes/reveal-on-hover',
    './attributes/reveal-on-click',
    './attributes/close-on-click',
    './attributes/toggle-on-click',
    './attributes/reveal',
    './attributes/language-chooser',
    './elements/flutscher/flutscher',
    './elements/swiper/swiper',
    './attributes/smooth-scroll',
    './attributes/scroll-to-top',
  ]);
}
